import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'; 
import { NzPlacementType } from 'ng-zorro-antd/dropdown';
import { VhQueryAutoWeb, VhImage, VhEventMediator } from 'vhautowebdb';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';



@Component({
  selector: 'atw-image-video-detail-image-admin-config',
  templateUrl: './image-video-detail-image-admin-config.component.html',
  styleUrls: ['./image-video-detail-image-admin-config.component.scss']
})
export class AtwImageVideoDetailImageAdminConfig  extends AtwUpdateDbComponent  implements OnInit {
 @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() data: any = {};
  @Output() save = new EventEmitter();
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database

  style_fields = [
    {
      title: "thong_so_co_ban",
      index: 1,
      isDrop: false
    },
    {
      title: "bo_loc_hinh_anh",
      index: 2,
      isDrop: false
    },
    {
      title: "do_bao_phu",
      index: 3,
      isDrop: false
    },
    {
      title: "khung_chua",
      index: 4,
      isDrop: false
    },
    {
      title: "do_bong",
      index: 5,
      isDrop: false
    },
    {
      title: "hieu_ung_va_thao_tac",
      index: 6,
      isDrop: false
    },
    {
      title: "bien_doi",
      index: 7,
      isDrop: false
    }, {
      title: "them_lien_ket",
      index: 8,
      isDrop: false
    },
    {
      title: 'dieu_chinh_vien_anh_chinh',
      index: 9,
      isDrop: false
    }
  ]

  border_styles: any = [
    {
      name: 'solid',
      data: 'https://cdn.icon-icons.com/icons2/953/PNG/512/straight-horizontal-line_icon-icons.com_74237.png'
    },
    {
      name: 'dashed',
      data: 'https://115.78.228.208:20350/bvhsales/lXjeqUwuBqScIkuf7sibcx2SF383/assets/auto-web/dashed-line-02.png'
    },
    {
      name: 'dotted',
      data: 'https://115.78.228.208:20350/bvhsales/lXjeqUwuBqScIkuf7sibcx2SF383/assets/auto-web/dotted-line-02.png'
    }
  ]

  shadow_styles: any = [
    {
      name: 'type 1',
      data: 'rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset'
    },
    {
      name: 'type 2',
      data: 'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px'
    },
    {
      name: 'type 3',
      data: 'rgb(38, 57, 77) 0px 20px 30px -10px'
    },
    {
      name: 'type 4',
      data: 'rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px'
    }
  ]

  hover_styles: any = [
    {
      name: "Mặc định",
      data: "action-default",
      img: "/assets/root/images/system/imgs/effect-hover-default.jpg"
    },
    {
      name: "Phóng to",
      data: "hover-zoom-in",
      img: "/assets/root/images/system/imgs/effect-hover-zoom-in.jpg"
    },
    {
      name: "Thu nhỏ",
      data: "hover-zoom-out",
      img: "/assets/root/images/system/imgs/effect-hover-zoom-out.jpg"
    },
    {
      name: "Phủ sáng",
      data: "hover-opacity",
      img: "/assets/root/images/system/imgs/effect-hover-light-cover.jpg"
    },
    {
      name: "Hiện viền",
      data: "hover-border",
      img: "/assets/root/images/system/imgs/effect-hover-border.jpg"
    }
  ]

  border_url: string = 'https://cdn.icon-icons.com/icons2/953/PNG/512/straight-horizontal-line_icon-icons.com_74237.png';
  currentViewAll: any = {};
  formatterPercent = (value: number): string => `${value} %`;
  parserPercent = (value: string): string => value.replace(' %', '');
  isViewAll: boolean = false;
  //Các field cho phép sử dụng
  isApplyBorder: boolean = false;
  isApplyShadow: boolean = false;
  isApplyHover: boolean = false;
  rotateField: any = '';
  actionFieldSetting: string = '';
  clicked: any = {};
  arr_link_page: any;
  id_subproject: any = "";
  isImageSaved: boolean = true;
  menuDrop: any = "";
  positionSelect: NzPlacementType = 'bottomCenter';
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private vhImage: VhImage, 
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService,
    public vhEventMediator: VhEventMediator,
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }



  ngOnInit(): void {
    
    // this.setApplyField();
  }

  // Kiểm tra giá trị đầu vào của border, shadow, thao tác ....
  setApplyField() {
    //Border
    if (this.data.desktop_border_image.border === 'none')
      this.isApplyBorder = false;
    else
      this.isApplyBorder = true;
    //Shadow
    if (this.data.box_shadow === 'none')
      this.isApplyShadow = false;
    else
      this.isApplyShadow = true;
  }

  isOpenViewAll(event) {
    this.currentViewAll = event;
    this.isViewAll = !this.isViewAll;
  }

  onDropMenu(num) {
    this.menuDrop = num;
  }

  clearDrop() {
    
  }

  // Lưu DB
  updateCss(fieldName) {
    this.save.emit(fieldName)
  }

  /**
  *Hàm update class vào database.
  */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {

      })
  }

  //Chọn kiểu bóng có sẵn
  onShadowSelected(value, event) {
    if (isPlatformBrowser(this.platformId)){
    this.data.desktop_shadow_image.box_shadow = value.data;
    var lastSelectElm = document.querySelector('.box-shadow .selected') as HTMLElement;
    if (lastSelectElm)
      lastSelectElm.classList.remove('selected')
    event.currentTarget.classList.add("selected")
    this.updateCss('desktop_shadow_image');}
  }
  //Chọn kiểu thao tác có sẵn
  onActionSelected(value, event) {
    if (isPlatformBrowser(this.platformId)){
    this.data.desktop_classes_image.action_class = value.data;
    var lastSelectElm = document.querySelector('.action .selected') as HTMLElement;
    if (lastSelectElm)
      lastSelectElm.classList.remove('selected')
    event.currentTarget.classList.add("selected")
    this.updateCss('desktop_classes_image');}
  }

  onActionSwitch(value, event) {
    if (event.checked)
      this.data.desktop_classes_image.action_class = value;
    else
      this.data.desktop_classes_image.action_class = 'action-default'
    this.updateCss('desktop_classes_image');
  }

  onAxisSwitch(event) {
    if (event.checked)
      this.data.desktop_classes_image.axis_class = 'show-axis';
    else
      this.data.desktop_classes_image.axis_class = '';
    this.updateCss('desktop_classes_image');
  }

  // hàm cập nhật bộ lọc hình ảnh
  updateScale() {
    this.class['image-img'].transform = "scale(" + this.config['transform_image'].transform_scale + ")"
    this.updateClass();
  }

  onActionSetting(value, event) {
    event.stopPropagation();
    if (value.data)
      this.actionFieldSetting = value.data;
    else
      this.actionFieldSetting = 'all';
    this.openViewAll(this.style_fields[5]);

  }
  //Mở xem thêm
  openViewAll(field) {
    this.currentViewAll = field;
    this.isViewAll = !this.isViewAll;
  }

  //Xử lí border-radius
  handleSetBorderRadius() {
    if (this.data.desktop_border_image.border_radius > 0) {
      this.data.desktop_border_image.border_top_left_radius = this.data.desktop_border_image.border_radius;
      this.data.desktop_border_image.border_top_right_radius = this.data.desktop_border_image.border_radius;
      this.data.desktop_border_image.border_bottom_left_radius = this.data.desktop_border_image.border_radius;
      this.data.desktop_border_image.border_bottom_right_radius = this.data.desktop_border_image.border_radius;
    }
    this.updateCss('desktop_border_image');
  }
  // Xử lí lưu border
  handleSetBorder() {
    // 
    if (this.isApplyBorder == false)
      this.data.desktop_border_image.border = `none`
    else
      this.data.desktop_border_image.border = `${this.data.desktop_border_image.border_width}px ${this.data.desktop_border_image.border_style} ${this.data.desktop_border_image.border_color}`
    this.updateCss('desktop_border_image');
  }
  // Xử lí lưu bóng
  // handleSetShadow() {
  //   if (this.isApplyShadow == false)
  //     this.data.desktop_shadow_image.box_shadow = `none`
  //   else {
  //     this.data.desktop_transform_image.transform_scale = 0.8;
  //     this.data.desktop_shadow_image.box_shadow = `${this.data.desktop_shadow_image.box_shadow_x}px ${this.data.desktop_shadow_image.box_shadow_y}px ${this.data.desktop_shadow_image.box_shadow_blur}px ${this.data.desktop_shadow_image.box_shadow_color}`;
  //   }
  //   this.updateCss('desktop_transform_image');
  // }
  // Xử lí lưu vị trí ảnh
  handleSetPositionImage() {
    if (this.config['object_fit_image']['object_x'] == 0 && this.config['object_fit_image']['object_y'] == 0)
      this.class['image-img']['object-position'] = 'initial';
    else {
      this.class['image-img']['object-position'] = `${this.config['object_fit_image']['object_x']}px ${this.config['object_fit_image']['object_y']}px`;
    }
    this.updateClass()
  }
  /** Xử lí đổ bóng
* -> xử lí dữ liệu bóng -> css:  object-position: `x y blur color`
*/
  handleSetPositionShadow() {
    this.class['image-img']['box-shadow'] = `${this.config['box-shadow'].box_shadow_x}px ${this.config['box-shadow'].box_shadow_y}px ${this.config['box-shadow'].box_shadow_blur}px ${this.config['box-shadow'].box_shadow_width}px ${this.config['box-shadow'].box_shadow_color}`;
    this.updateObject();
  }
  /**
* Hàm update object vào database.
*/
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {

      })
  }
  // Xử lí lưu vị trí xoay, lật
  handleSetTransform(axis) {
    switch (axis) {
      case 'x':       // ---Lật dọc
        if (this.data.desktop_transform_image.transform_rotateX < 360)
          this.data.desktop_transform_image.transform_rotateX += 180;
        else
          this.data.desktop_transform_image.transform_rotateX -= 180;
        break;
      case 'y':       // ---Lật ngang
        if (this.data.desktop_transform_image.transform_rotateY < 360)
          this.data.desktop_transform_image.transform_rotateY += 180;
        else
          this.data.desktop_transform_image.transform_rotateY -= 180;
        break;
      case '-z':        // --- Xoay trái
        if (this.data.desktop_transform_image.transform_rotateZ > -360)
          this.data.desktop_transform_image.transform_rotateZ -= 90;
        break;
      case 'z':         // --- Xoay phải
        if (this.data.desktop_transform_image.transform_rotateZ < 360)
          this.data.desktop_transform_image.transform_rotateZ += 90;
        break;
      default:
    }
    this.updateCss('desktop_transform_image')
  }

  //Chọn kiểu viền
  selectBorderStyle(item) {
    this.data.desktop_border_image.border_style = item.name;
    this.border_url = item.url;
    this.handleSetBorder();
  }

  /** Chuyển đổi giá trị sang % 
   * max : Giá trị tối đa
   * number : Giá trị cần chuyển
  */
  exchangeValue(max, number) {
    return Math.round(number / (max / 100))
  }

  /** UPLOAD IMAGE */
  openUpload() {
    if (isPlatformBrowser(this.platformId)){
    var inputVal = document.querySelector('#upload') as HTMLElement;
    inputVal.click();}
  }


  onUpload(e) {
    const file = e.target.files[0];
    // 
    this.vhImage.getImageFromDesktop(file, "autoweb_upload_image", this.data.img).then(
      (photoURL: any) => {
        this.data.data.img = photoURL;
        // 
      },
      (error) => {
        // 
        // this.vhComponent.showToast(2000, (this.languageService.translate("Image was failed")));
      }
    );
  }
}
